import React from 'react';
import './LoadingGameSelector.css';

/**
 * LoadingGameSelector - Minimal icon-only game selector for loading screens
 * 
 * Features:
 * - Clean icon buttons with no background cards
 * - Horizontal scrollable layout
 * - Selected state shown via glow ring
 * - Uses official Scout game icons from public/scout_images/games/
 * 
 * Props:
 * - selectedGame: string | null - Currently selected game ID
 * - onSelect: (gameId: string) => void - Callback when game is selected
 * - disabledGames: string[] - List of game IDs that should be disabled
 */
export default function LoadingGameSelector({ 
  selectedGame, 
  onSelect, 
  disabledGames = [] 
}) {
  const games = [
    {
      id: 'sidetosidecatcher',
      name: 'Side-to-Side',
      icon: '/scout_images/games/scout_sidetoside_icon.png',
    },
    {
      id: 'dodge',
      name: 'Dodge',
      icon: '/scout_images/games/scout_dodge_survival_icon.png',
    },
    {
      id: 'runner',
      name: 'Runner',
      icon: '/scout_images/games/scout_endless_runner_icon.png',
    },
    {
      id: 'taptojump',
      name: 'Tap Jump',
      icon: '/scout_images/games/scout_taptojump_icon.png',
    },
    {
      id: 'whack',
      name: 'Whack',
      icon: '/scout_images/games/scout_wackdistraction_icon.png',
    },
  ];

  return (
    <div className="loading-game-selector">
      <div className="game-icon-rail">
        {games.map(game => {
          const isDisabled = disabledGames.includes(game.id);
          const isSelected = selectedGame === game.id;
          
          return (
            <div key={game.id} className={`game-option ${isSelected ? 'selected' : ''} ${isDisabled ? 'disabled' : ''}`}>
              {isDisabled && (
                <span className="coming-soon-pill">COMING SOON</span>
              )}
              <button
                className="icon-button"
                onClick={() => !isDisabled && onSelect(game.id)}
                disabled={isDisabled}
                title={isDisabled ? `${game.name} - Coming Soon` : game.name}
                aria-label={game.name}
                aria-pressed={isSelected}
              >
                <img 
                  src={game.icon} 
                  alt="" 
                  className="icon-img"
                  draggable="false"
                />
              </button>
              <div className="game-label">
                {game.name}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
